import { render } from "./DataTableSelection.vue?vue&type=template&id=cef54668&scoped=true"
import script from "./DataTableSelection.vue?vue&type=script&lang=js"
export * from "./DataTableSelection.vue?vue&type=script&lang=js"

import "./DataTableSelection.vue?vue&type=style&index=0&id=cef54668&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef54668"]])

export default __exports__